import { useMutation } from "@apollo/client"
import { INVITE_MEMBERS_TO_GROUP } from "../graphql/mutations/inviteMembersToGroup"
import { GET_SUGGESTED_GROUPS_USER } from "../graphql/queries/getSuggestedGroupsUser"
import { GET_MY_ORG_GROUPS } from "../graphql/queries/getMyOrgGroups"
import { GET_ALL_MEMBERS } from "../graphql/queries/getAllMembers"
import { GET_ALL_GROUPS } from "../graphql/queries/getAllGroups"

export const useInviteMembersToGroup = ({ onCompleted, onError }: { onCompleted: any; onError: any }) => {
  const [inviteMembersToGroup, { client, data, loading }] = useMutation(INVITE_MEMBERS_TO_GROUP, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_SUGGESTED_GROUPS_USER, GET_ALL_MEMBERS, GET_MY_ORG_GROUPS, GET_ALL_GROUPS],
  })

  return { inviteMembersToGroup, data, loading, client }
}
